import $ from 'jquery'
var utils={
    HandleUrl(_url){
        if (_url===undefined) return '';
        if (_url.indexOf('http')!=0){
            return 'http://'+_url;
        }
        return _url;
    },
    ShowContentBr:function(_content){
        if (_content==null||_content==undefined) return '';
        var reg=new RegExp("\n",'g');
        return  _content.replace(reg,"<br/>");
    },
    AddLoadMoreListener(_callback,_offset){
        var offset = 10;
        if(_offset != undefined && _offset > 0){
            offset = _offset;
        }
        
        if(typeof _callback === 'function'){
            var fun =function () { 
                //判断是否滚动到底部
                var scrollTop = document.documentElement.scrollTop;
                if(scrollTop === 0){
                    scrollTop = $(document).scrollTop();
                }
                if(scrollTop + window.innerHeight + offset >= $(document).height()){
                    _callback();
                }
            }
            //注册scroll事件并监听
            window.addEventListener('scroll',fun);
            return fun;
        }
    },
};

export default utils;  